var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('list-table',{attrs:{"url":'inandout?typeofpayment=0',"title":"تراکنش های بانک آینده","fields":_vm.fields1,"params":_vm.params,"excelroute":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }